import React, { useEffect, useState, memo } from "react";
import defaultLogo from "assets/img/logo.png";
import logokemenag from "assets/img/logo-kemenag.png";
import logoDiajeng from "assets/img/logoDiajeng.png";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const Footer = () => {
  const [logoUrl, setLogoUrl] = useState(defaultLogo);
  const [schoolProfile, setSchoolProfile] = useState({
    address: "Jl. Sisingamangaraja No.5, Wonotingal, Kec. Candisari, Kota Semarang, Jawa Tengah 50252",
    city: "Kota Semarang",
    province: "Jawa Tengah",
  });
  const [contact, setContact] = useState({
    email: "info@madrasahjateng.id",
    phone: "(024) 123-4567",
  });

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const res = await axios.get("/api_w/logo", {
          headers: { db_name: process.env.REACT_APP_DB_NAME },
        });
        const data = res?.data?.data;
        if (Array.isArray(data) && data.length > 0 && data[0].url) {
          setLogoUrl(data[0].url);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message || "Gagal memuat logo");
      }
    };

    fetchLogo();
  }, []);

  useEffect(() => {
    const fetchProfileAndContact = async () => {
      try {
        const [pRes, cRes] = await Promise.all([
          axios.get("/api_w/schoolprofiles"),
          axios.get("/api_w/contacts"),
        ]);

        const profiles = pRes?.data?.data || [];
        if (Array.isArray(profiles) && profiles.length > 0) {
          const p = profiles[0];
          setSchoolProfile((prev) => ({
            ...prev,
            address: p.address || prev.address,
            city: p.City?.name || prev.city,
            province: p.Province?.name || prev.province,
          }));
        }

        const contacts = cRes?.data?.data || [];
        if (Array.isArray(contacts) && contacts.length > 0) {
          const c = contacts[0];
          setContact((prev) => ({
            ...prev,
            email: c.email || prev.email,
            phone: c.phone || prev.phone,
          }));
        }
      } catch (err) {
        console.error("Footer data error:", err);
      }
    };

    fetchProfileAndContact();
  }, []);

  const quickLinks = [
    { label: "Beranda", to: "/" },
    { label: "Fitur", to: "#" },
    { label: "Program", to: "#" },
    { label: "Berita", to: "/berita" },
    { label: "FAQ", to: "/faq" },
  ];

  const services = [
    { label: "Platform Pembelajaran", to: "#" },
    { label: "Pelatihan Guru", to: "#" },
    { label: "Konsultasi", to: "#" },
  ];

  const socialLinks = [
    { label: "Facebook", icon: <FaFacebookF />, to: "#" },
    { label: "Instagram", icon: <FaInstagram />, to: "#" },
    { label: "Twitter", icon: <FaTwitter />, to: "#" },
    { label: "YouTube", icon: <FaYoutube />, to: "#" },
  ];

  return (
    <footer className="bg-[#13733A] text-white">
      <div className="mx-auto max-w-[1200px] px-6 py-10 sm:px-8 sm:py-14 lg:px-16 lg:py-20">
        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1.2fr]">
          <div>
            <div className="mb-4 flex items-center gap-6">
              {/* Logo madrasah: tidak rounded, diperbesar responsif */}
              <div className="flex items-center justify-center overflow-hidden h-20 w-20 sm:h-24 sm:w-24 md:h-28 md:w-28">
                <img
                  src={logoDiajeng}
                  alt="Logo Madrasah"
                  className="h-full w-full object-contain"
                  loading="lazy"
                />
              </div>

              {/* Logo Kemenag: diperbesar responsif */}
              <div className="flex items-center">
                <img
                  className="md:h-18 h-14 w-auto object-contain sm:h-14"
                  src={logokemenag}
                  alt="Logo Kemenag"
                  loading="lazy"
                />
              </div>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-tight">
              Madrasah Jateng Digital Learning
            </h2>

            <p className="mt-3 max-w-lg text-sm sm:text-base text-white/80">
              Jl. Sisingamangaraja No.5, Wonotingal, Kec. Candisari, Kota Semarang, Jawa Tengah 50252
            </p>

            <div className="mt-4 flex gap-3">
              {socialLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.to}
                  aria-label={item.label}
                  className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#004832] text-lg text-white/90 transition hover:bg-[#003826] hover:text-white"
                  target={item.to?.startsWith("http") ? "_blank" : undefined}
                  rel={item.to?.startsWith("http") ? "noopener noreferrer" : undefined}
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          <FooterColumn title="Tautan Cepat" links={quickLinks} />
          <FooterColumn title="Layanan" links={services} />

          <div>
            <h3 className="text-xl sm:text-2xl font-bold">Kontak Kami</h3>

            <div className="mt-6 space-y-4 text-sm sm:text-base text-white/80">
              <a
                href={`tel:${contact.phone}`}
                className="flex items-center gap-3 hover:text-white"
                aria-label={`Telepon ${contact.phone}`}
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#004832] text-lg text-white">
                  <MdPhone />
                </span>
                <span>{contact.phone}</span>
              </a>

              <a
                href={`mailto:${contact.email}`}
                className="flex items-center gap-3 hover:text-white"
                aria-label={`Email ${contact.email}`}
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#004832] text-lg text-white">
                  <MdEmail />
                </span>
                <span>{contact.email}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-white/30 pt-6">
          <div className="flex flex-col gap-4 text-xs sm:text-sm text-white/90 md:flex-row md:items-center md:justify-between">
            <p>&copy; {new Date().getFullYear()} Madrasah Jateng Digital Learning. All rights reserved.</p>

            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/privacy-policy" className="hover:text-white/75">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="hover:text-white/75">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterColumn = memo(({ title, links }) => (
  <div>
    <h3 className="text-xl sm:text-2xl font-bold">{title}</h3>

    <nav className="mt-4 flex flex-col gap-2 text-sm sm:text-base text-white/75">
      {links.map((item) => (
        <Link key={item.label} to={item.to} className="transition hover:text-white">
          {item.label}
        </Link>
      ))}
    </nav>
  </div>
));

export default Footer;